<script setup lang="ts">
import type { Event } from "#shared/types/events";

const props = defineProps<{ event: Event }>();

const isFullyBooked = computed(() => {
  const maxDate = new Date(
    Math.max(...props.event.dates.map((it) => it.getTime())),
  );

  return isFuture(maxDate) && props.event.signUpForm && props.event.fullBooked;
});

const maxWidth = "57rem";
</script>

<template>
  <section class="event-hero" :class="[event.eventType]">
    <div class="relative">
      <CardsEventCover
        :event="event"
        placeholder
        :sizes="maxWidth"
        class="sm:rounded-none"
      />
      <UiGraphicsDateBox
        class="absolute bottom-8 left-8 sm:left-16"
        :dates="event.dates"
        aria-hidden="true"
      />
    </div>
    <div class="event-hero__info">
      <UiCommonsTag :event="event" size="medium" />
      <CardsEventTitle
        tag="h1"
        :event="event"
        class="info__title"
      />
      <CardsEventDates
        :event="event"
        weekday="long"
        class="info__element"
      />
      <CardsEventTime :event="event" class="info__element" />
      <CardsEventLocation
        :event="event"
        class="info__element"
        hide-webinar-link
      />
      <CardsEventVideoLink :event="event" class="info__element" />
      <CardsEventAddress :event="event" class="info__element" />
      <CardsEventExternalSite :event="event" class="info__element" />
      <p v-if="isFullyBooked" class="info__element">
        Arrangementet er dessverre fullbooket
      </p>
    </div>
  </section>
</template>

<style scoped lang="scss">
.event-hero {
  max-width: v-bind(maxWidth);
  padding-bottom: 2rem;
  border-radius: 1rem;
  color: theme("colors.green.50");
  height: min-content;
  text-decoration: none;
  font-size: pixelsToRem(18);
  margin: 0 auto 3rem;
  background-color: var(--event-background);

  @media screen and (min-width: $extra-small) {
    margin: 3rem auto;
  }

  &__info {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 1.5rem 2rem;

    @media screen and (min-width: $extra-small) {
      padding: 1.5rem 4rem;
    }

    .info__element {
      margin-top: 0.1rem;

      & + p {
        margin-top: 1.5rem;
      }
    }

    .info__title {
      font-size: pixelsToRem(30);
      font-weight: 400;
      letter-spacing: 0.1rem;
      line-height: pixelsToRem(40);

      @media screen and (min-width: $extra-small) {
        font-size: pixelsToRem(40);
        line-height: pixelsToRem(50);
      }

      @media screen and (min-width: $small) {
        font-size: pixelsToRem(60);
        line-height: pixelsToRem(70);
      }
    }
  }
}
</style>
